import React, { Component, Fragment } from "react";
import EmptyState from "../../common/EmptyState";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const MONTH_NAMES = [
  "January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December",
];

// month looks like "April,2026" — parse into a real Date so months sort
// chronologically (newest first) instead of alphabetically.
function parseMonthId(id) {
  const [monthName, year] = String(id).split(",");
  const monthIndex = MONTH_NAMES.indexOf((monthName || "").trim());
  return new Date(parseInt(year, 10) || 0, monthIndex >= 0 ? monthIndex : 0, 1);
}

export class Datatable extends Component {
  render() {
    const { myData, history } = this.props;

    const rows = [...(myData || [])].sort(
      (a, b) => parseMonthId(b) - parseMonthId(a)
    );

    return (
      <Fragment>
        <div className="cs-table-wrap">
          <table className="table cs-table kd-month-grid">
            <thead>
              <tr>
                <th scope="col">Month</th>
                <th scope="col" className="cs-col-action">Inspect</th>
              </tr>
            </thead>
            <tbody>
              {rows.length === 0 ? (
                <tr>
                  <td colSpan={2} className="cs-empty">
                    <EmptyState>No records yet.</EmptyState>
                  </td>
                </tr>
              ) : (
                rows.map((month, i) => (
                  <tr key={i}>
                    <td>{month}</td>
                    <td className="cs-col-action">
                      <button
                        type="button"
                        className="cs-icon-btn"
                        onClick={() => {
                          history.push(`/cash-summary/${month}`);
                        }}
                      >
                        <i className="fa fa-eye"></i>
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
        <ToastContainer />
      </Fragment>
    );
  }
}

export default Datatable;
